// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

export default {
	namespaced: true,
	state: {
		modeOfCommutes: [],
	},
	getters: {

	},
	mutations: {
		SET_MODE_OF_COMMUTES: (state, modeOfCommutes) => {
			state.modeOfCommutes = modeOfCommutes;
		},
	},
	actions: {
		loadMotivationQuestionnaire: async ({ rootGetters }) => {
			const url = '/api/v3/motivation-questionnaire-by-theme';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		getMotivationQuestionnaries: async ({ rootGetters }) => {
			const url = '/api/v3/motivation-questionnaire';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		createMotivationQuestionarrie: async (
			{ rootGetters },
			motivationQuestionnarie,
		) => {
			const url = '/api/v3/motivation-questionnaire';
			const results = await feathersClient.service(url).create(motivationQuestionnarie, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateMotivationQuestionnaire: async ({ rootGetters }, motivationQuestions) => {
			const url = '/api/v3/motivation-questionnaire';
			const results = await feathersClient.service(url).patch(motivationQuestions.id, motivationQuestions, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		deleteMotivationQuestionnaire: async ({ rootGetters }, id) => {
			const url = '/api/v3/motivation-questionnaire';
			const results = await feathersClient.service(url).remove(id, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		createRankMotivator: async ({ rootGetters }, motivationPreference) => {
			const url = '/api/v3/motivation-preferences';
			const results = await feathersClient.service(url).create(motivationPreference, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		loadRankMotivators: async () => {
			const url = '/api/v3/motivation-preferences';
			const results = await feathersClient.service(url).find({});
			return results;
		},
		updateRankMotivator: async ({ rootGetters }, rankMotivator) => {
			const url = '/api/v3/motivation-preferences';
			const results = await feathersClient.service(url).patch(rankMotivator.id, rankMotivator, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		deleteRankMotivator: async ({ rootGetters }, id) => {
			const url = '/api/v3/motivation-preferences'; // super-admin
			const results = await feathersClient.service(url).remove(id, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		loadModeOfCommutes: async ({ commit }) => {
			const url = '/api/v3/modeofcommute';
			const results = await feathersClient.service(url).find({});
			commit('SET_MODE_OF_COMMUTES', results);
			
			return results;
		},
		createModeOfCommute: async ({ rootGetters }, modeOfCommute) => {
			const url = '/api/v3/modeofcommute';
			const results = await feathersClient.service(url).create(modeOfCommute, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateModeOfCommute: async ({ rootGetters }, modeOfCommute) => {
			const url = '/api/v3/modeofcommute';
			const results = await feathersClient.service(url).patch(modeOfCommute.id, modeOfCommute, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		deleteModeOfCommute: async ({ rootGetters }, modeOfCommuteId) => {
			const url = '/api/v3/modeofcommute';
			const results = await feathersClient.service(url).remove(modeOfCommuteId, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
	},
};
